<template>
  <div class="custom-list-wrapper">
    <div v-if="loadingContact">
      <span>Loading...</span>
    </div>
    <div class="custom-list-header" v-show="!loadingContact">
      <b-button variant="outline-secondary" size="sm" @click="newEmail" class="margin-right-5">Add</b-button>
      <b-button variant="outline-secondary" size="sm" @click="confirmDelete" v-show="isShowDelete"
        class="margin-right-5">Delete</b-button>
      <b-button variant="outline-secondary" size="sm" @click="primaryEmail"
        v-show="isShowPrimary && recordChecked && !recordChecked.isPrimary" class="margin-right-5">Set as
        Primary</b-button>
      <span class="custom-title" v-show="showTitle">Email Addresses</span>
    </div>
    <div class="custom-list" v-show="!loadingContact">
      <div v-for="item of contactEmails" :key="item.contactEmail">
        <ContactEmailRecord :recordData="item" @itemChecked="itemChecked" @editItem="editEmail" />
      </div>
    </div>
    <DialogEmail v-model="actionEmail" :value="actionEmail" :email="emailRecord" @closing="closeModal"
      @send="sendEmail" />
    <ConfirmDelete v-model="actionDelete" :value="actionDelete" :tag="'Email(s)'" @closing="closeModal"
      @delete="performDelete" />
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { contacts } from '@/stores'
import DialogEmail from '@/components/contacts/forms/email.vue'
import ContactEmailRecord from '@/components/contacts/listings/contact-email-record.vue'
import ConfirmDelete from '@/components/contacts/forms/confirm-delete.vue'
export default {
  name: 'contact-emails',
  components: {
    DialogEmail,
    ContactEmailRecord,
    ConfirmDelete
  },
  props: {
    contact: {
      type: Object
    },
    showTitle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      actionEmail: null,
      actionDelete: null,
      isShowDelete: false,
      isShowPrimary: false,
      recordChecked: null,
      emailRecord: undefined
    }
  },
  computed: {
    ...mapState(contacts, ['contactEmails', 'loadingContact'])
  },
  methods: {
    ...mapActions(contacts, [
      'saveEmail',
      'deleteEmail',
      'setPrimaryEmail',
      'setCheckedEmail',
      'getContactEmails',
      'addEmail'
    ]),
    closeModal() {
      this.actionEmail = null
      this.actionDelete = null
      this.emailRecord = undefined
      this.recordChecked = null
    },
    itemChecked(value, checked) {
      this.isShowDelete = checked
      this.isShowPrimary = checked
      this.recordChecked = null
      if (checked) {
        this.recordChecked = value
      }
      this.setCheckedEmail({
        contactEmail: value.contactEmail,
        isChecked: checked
      })
    },
    newEmail() {
      var email = {
        firm: this.contact.firm,
        contact: this.contact.contact,
        contactEmail: -1,
        emailAddress: '',
        emailType: 0,
        emailTypeName: '',
        primary: ''
      }
      this.addEmail(email)
      this.emailRecord = email
      this.actionEmail = this.contact
    },
    editEmail(data) {
      this.emailRecord = data
      this.actionEmail = this.contact
    },
    confirmDelete() {
      this.actionDelete = true
    },
    async performDelete() {
      this.actionDelete = false
      this.isShowDelete = false
      this.isShowPrimary = false
      this.recordChecked = null
      let emails = []
      for (let email of this.contactEmails) {
        if (email.isChecked) {
          emails.push({
            contactEmail: email.contactEmail,
            contact: this.contact.contact
          })
        }
      }
      for (let email of emails) {
        await this.deleteEmail(email)
      }
      await this.getContactEmails(this.contact.contact)
    },
    async primaryEmail() {
      let data = {
        id: this.recordChecked.contactEmail,
        contact: this.contact.contact
      }
      await this.setPrimaryEmail(data)
      this.isShowDelete = false
      this.isShowPrimary = false
      this.recordChecked = null
    },
    async sendEmail(data) {
      this.actionEmail = null
      this.emailRecord = undefined
      var email = this.contactEmails.find(
        x => parseInt(x.contactEmail) === parseInt(data)
      )
      if (email !== null) {
        await this.saveEmail(email)
        await this.getContactEmails(this.contact.contact)
        this.$emit('onupdate', this.contact.contact)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-list-wrapper {
  background-color: #ffffff;
  max-height: 210px;
  height: 210px;
  padding: 2px;
}

.custom-list-header {
  text-align: left;
  padding: 5px;
  border-bottom: 1px solid rgb(144, 144, 144);
  margin-bottom: 5px;
}

.custom-list {
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 5px;
  margin-left: 5px;
  margin-right: 5px;
  height: 155px;
}

.custom-title {
  float: right;
  position: relative;
}
</style>
